import { ReactElement } from "react";

const ShareIcon = (): ReactElement => (
  <svg
    height="21px"
    version="1.1"
    viewBox="0 0 525.152 525.152"
    width="20px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Share</title>
    <desc>Created with Sketch.</desc>
    <g fill="none" fillRule="evenodd" id="Capa_1" stroke="none" strokeWidth="1">
      <g
        fill="#000000"
        id="Capa_1"
        transform="translate(-181.000000, -1869.000000)"
      >
        <g transform="translate(173.000000, 1861.000000)">
          <path
            d="M420.735,371.217c-20.021,0-37.942,7.855-51.596,20.24L181.112,282.094c1.357-6.061,2.407-12.166,2.407-18.468c0-6.302-1.072-12.385-2.407-18.468l185.904-108.335c14.179,13.129,32.931,21.334,53.719,21.334c43.828,0,79.145-35.251,79.145-79.079C499.88,35.338,464.541,0,420.735,0c-43.741,0-79.079,35.338-79.079,79.057c0,6.389,1.072,12.385,2.407,18.468L158.158,205.947c-14.201-13.194-32.931-21.378-53.741-21.378c-43.828,0-79.145,35.317-79.145,79.057s35.317,79.079,79.145,79.079c20.787,0,39.54-8.206,53.719-21.334l187.698,109.604c-1.291,5.58-2.101,11.4-2.101,17.199c0,42.45,34.594,76.979,76.979,76.979c42.428,0,77.044-34.507,77.044-76.979S463.163,371.217,420.735,371.217z"
            id="svg"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default ShareIcon;
